export enum TipoAgendamentoEnum {
  LOJA = "LOJA",
  DOMICILIO = "DOMICILIO",
  ITINERANTE = "ITINERANTE",
}
